import { Component, Input, OnInit } from '@angular/core';
import { ChartData, ChartOptions } from 'chart.js';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-linegraph',
  templateUrl: './linegraph.component.html',
  styleUrls: ['./linegraph.component.scss']
})
export class LinegraphComponent {
  @Input() data: any;

  startDate: Date  = new Date('09-09-2023');
  endDate: Date = new Date();
  today: Date = new Date();
  graphData: any;
  chartData: any;
  chartOptions: any;

  usedColors: string[] = [];

  constructor( private dataService: DataService,) {}

  async ngOnInit() {
    const jsonData = await this.getDataFromArg(this.data);
    
    // Prepare chart data and options
    this.chartData = {
      labels: jsonData.map((item: any) => item.key),
      datasets: [
        {
          label: this.data.graphname,
          data: jsonData.map((item: any) => item.count),
          fill: false,
          borderColor: this.getUniqueColor()
        }
      ]
    };

    this.chartOptions = {
      scales: {
        xAxes: [
          {
            type: 'time',
            time: {
              unit: 'day',
              displayFormats: {
                day: 'YYYY-MM-DD'
              },
            },
            scaleLabel: {
              display: true,
              labelString: 'Date'
            }
          }
        ],
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: 'Activity Count'
            }
          }
        ],
        x: {
          ticks: {
            font: {
              size: 12,
              family: 'SSTArabic'
            }, color :'white'
          }
        },
        y: {
          ticks: {
            font: {
              size: 12,
              family: 'SSTArabic'
            },  color :'white'
          }
        }
      },
      plugins: {
        legend: {
          labels: {
            font: {
              size: 14,
              family: 'SSTArabic'
            },  color :'white'
          }
        }
      }
    };
  }

  async getDataFromArg(data: any, startDate?: Date, endDate?: Date) {

    let managerOu: any = localStorage.getItem('managerOus');

    managerOu = managerOu ? JSON.parse(managerOu) : null;

    if (data.tag && data.tag === 'MANAGER' && managerOu && managerOu.length > 0) {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: data.aggregation,
          tableName: data.table,
          timeRange: (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
          managerOus: managerOu
        }
      );
      return res.data;
    } else {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: data.aggregation,
          tableName: data.table,
          timeRange:  (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
        }
      );
      return res.data;
    }
  }

  getUniqueColor() {
    const colors = [
      "#F7517F",
      "#252a68b8",
      "#082f4eb8",
      "#234b91b8",
      "#5953a2b8",
      "#77318cb8",
      "#532a7db8",
      '#2a0450b8',
      '#300a3b', '#2a0450', '#082f4e', '#011941', '#110d49'
    ];
  
    // Check if all colors have been used, reset the usedColors array
    if (this.usedColors.length === colors.length) {
      this.usedColors = [];
    }
  
    // Find a color that hasn't been used yet
    let color = '';
    for (const c of colors) {
      if (!this.usedColors.includes(c)) {
        color = c;
        this.usedColors.push(c);
        break;
      }
    }
  
    return color;
  }

  async makeChart(jsonData: any) {
    return {
      labels: jsonData.map((item: any) => item.key),
      datasets: [
        {
          label: this.data.graphname,
          data: jsonData.map((item: any) => item.count),
          fill: false,
          borderColor: this.getUniqueColor()
        }
      ]
    }
  }

  async onDateChange() {
    this.graphData = await this.getDataFromArg(this.data, this.startDate, this.endDate);
    this.chartData = await this.makeChart(this.graphData)
  }
}
